import { teamKit, readableOn, initialsOf } from "../../utils/footballTeams";

/**
 * PlayerJersey — crisp SVG kit with the player's number, two-tone by nation.
 * Falls back to initials silhouette. Used on the pitch (jersey) — player list
 * rows use the photo separately.
 */
export const PlayerJersey = ({ player = {}, size = 52, badge = null }) => {
  const [primary, secondary] = teamKit(player.team_name, player.team_id);
  const numColor = readableOn(primary);
  const number = player.jersey_number ?? "";
  const label = number !== "" ? String(number) : initialsOf(player.name);

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      style={{ filter: "drop-shadow(0 3px 4px rgba(0,0,0,0.45))" }}
      data-testid={`jersey-${player.player_id || "x"}`}
    >
      {/* sleeves (secondary) */}
      <path d="M22 6 L8 16 L13 27 L21 21 Z" fill={secondary} />
      <path d="M42 6 L56 16 L51 27 L43 21 Z" fill={secondary} />
      {/* body (primary) */}
      <path
        d="M22 6 C26 11, 38 11, 42 6 L43 21 L43 58 L21 58 L21 21 Z"
        fill={primary}
        stroke="rgba(0,0,0,0.18)"
        strokeWidth="1"
      />
      {/* collar accent */}
      <path d="M26 7 C28 11, 36 11, 38 7 L36 13 C34 15, 30 15, 28 13 Z" fill={secondary} />
      <text
        x="32"
        y="44"
        textAnchor="middle"
        fontSize={number !== "" ? "20" : "15"}
        fontWeight="800"
        fill={numColor}
        fontFamily="'Space Grotesk', sans-serif"
      >
        {label}
      </text>
      {/* Captain / VC badge — integrated onto the right shoulder of the kit */}
      {badge === "C" && (
        <g>
          <circle cx="49" cy="15" r="9" fill="hsl(43 96% 56%)" stroke="#0f172a" strokeWidth="1.6" />
          <text x="49" y="18.4" textAnchor="middle" fontSize="10" fontWeight="800" fill="#0f172a" fontFamily="'Space Grotesk', sans-serif">C</text>
        </g>
      )}
      {badge === "VC" && (
        <g>
          <circle cx="49" cy="15" r="9" fill="#e2e8f0" stroke="#0f172a" strokeWidth="1.6" />
          <text x="49" y="17.6" textAnchor="middle" fontSize="7.2" fontWeight="800" fill="#0f172a" fontFamily="'Space Grotesk', sans-serif">VC</text>
        </g>
      )}
    </svg>
  );
};

export default PlayerJersey;
